<template>
	<a @click="backToApp">App</a>
</template>

<script>
export default {
	methods: {
		backToApp() {
			location.replace("/");
		},
	},
};
</script>
